import { render, staticRenderFns } from "./MentorshipRequests.vue?vue&type=template&id=84aff3f2&scoped=true&"
import script from "./MentorshipRequests.vue?vue&type=script&lang=js&"
export * from "./MentorshipRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84aff3f2",
  null
  
)

export default component.exports